var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"social-button",on:{"click":_vm.onClick}},[_c('div',{staticClass:"logo"},[_c(_vm.icon+'-icon',{tag:"component"})],1),_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }